var _filter, _filter2, _marker, _marker2, _marker3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGuibuilderNodfloArchitecture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 550 420",
    width: 550,
    height: 420,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gbBg",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#f0fdf4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    style: {
      stopColor: "#ecfdf5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#f8fafc"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cardGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgba(255,255,255,0.97)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgba(255,255,255,0.88)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "guiGrad",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#34d399"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#059669"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nodfloGrad",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#fb923c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#ea580c"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "widgetGrad",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#60a5fa"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#2563eb"
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "gbShadow",
    x: "-15%",
    y: "-15%",
    width: "130%",
    height: "130%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 12,
    stdDeviation: 20,
    floodColor: "#0f172a",
    floodOpacity: 0.12
  }))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "softShadow",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 4,
    stdDeviation: 8,
    floodColor: "#0f172a",
    floodOpacity: 0.08
  }))), _marker || (_marker = /*#__PURE__*/React.createElement("marker", {
    id: "arrowGreen",
    markerWidth: 10,
    markerHeight: 10,
    refX: 9,
    refY: 3,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,6 L9,3 z",
    fill: "#059669"
  }))), _marker2 || (_marker2 = /*#__PURE__*/React.createElement("marker", {
    id: "arrowOrange",
    markerWidth: 10,
    markerHeight: 10,
    refX: 9,
    refY: 3,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,6 L9,3 z",
    fill: "#ea580c"
  }))), _marker3 || (_marker3 = /*#__PURE__*/React.createElement("marker", {
    id: "arrowBlue",
    markerWidth: 10,
    markerHeight: 10,
    refX: 9,
    refY: 3,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,6 L9,3 z",
    fill: "#2563eb"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.5)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 550,
    y: 44,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 24,
    fontWeight: 700,
    fill: "#064e3b",
    textAnchor: "middle"
  }, "GUIBuilder + NodFlo Runtime Integration"), /*#__PURE__*/React.createElement("text", {
    x: 550,
    y: 72,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fill: "#047857",
    textAnchor: "middle"
  }, "NodFlo extends GUIBuilder Player with backend automation logic and real-time tag exchange"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(80,110)",
    filter: "url(#gbShadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 260,
    height: 120,
    rx: 14,
    fill: "url(#cardGrad)",
    stroke: "#a7f3d0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 260,
    height: 40,
    rx: 14,
    fill: "url(#guiGrad)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 26,
    width: 260,
    height: 14,
    fill: "url(#guiGrad)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 130,
    y: 25,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 700,
    fill: "#fff",
    textAnchor: "middle"
  }, "\uD83C\uDFD7 GUIBuilder Designer"), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 54,
    width: 100,
    height: 24,
    rx: 5,
    fill: "#d1fae5"
  }), /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 70,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fill: "#065f46",
    textAnchor: "middle"
  }, "HMI Screens"), /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 54,
    width: 110,
    height: 24,
    rx: 5,
    fill: "#d1fae5"
  }), /*#__PURE__*/React.createElement("text", {
    x: 185,
    y: 70,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fill: "#065f46",
    textAnchor: "middle"
  }, "Tag Binding"), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 84,
    width: 220,
    height: 22,
    rx: 5,
    fill: "#ecfdf5"
  }), /*#__PURE__*/React.createElement("text", {
    x: 130,
    y: 99,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fill: "#065f46",
    textAnchor: "middle"
  }, "Drag-and-Drop SCADA Design")), /*#__PURE__*/React.createElement("path", {
    d: "M210 230 L210 260",
    stroke: "#059669",
    strokeWidth: 3,
    markerEnd: "url(#arrowGreen)",
    strokeLinecap: "round",
    strokeDasharray: "8,6"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "14;0",
    dur: "0.8s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(80,280)",
    filter: "url(#gbShadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 260,
    height: 160,
    rx: 14,
    fill: "url(#cardGrad)",
    stroke: "#34d399",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 260,
    height: 40,
    rx: 14,
    fill: "url(#guiGrad)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 26,
    width: 260,
    height: 14,
    fill: "url(#guiGrad)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 130,
    y: 25,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 15,
    fontWeight: 700,
    fill: "#fff",
    textAnchor: "middle"
  }, "\u25B6 GUIBuilder Player"), /*#__PURE__*/React.createElement("text", {
    x: 130,
    y: 56,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 600,
    fill: "#065f46",
    textAnchor: "middle"
  }, "Runtime Engine"), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 70,
    width: 100,
    height: 32,
    rx: 6,
    fill: "#d1fae5",
    stroke: "#86efac",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 90,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 700,
    fill: "#065f46",
    textAnchor: "middle"
  }, "Read Tags"), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 70,
    width: 100,
    height: 32,
    rx: 6,
    fill: "#d1fae5",
    stroke: "#86efac",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 190,
    y: 90,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 700,
    fill: "#065f46",
    textAnchor: "middle"
  }, "Write Tags"), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 112,
    width: 220,
    height: 32,
    rx: 6,
    fill: "#ecfdf5",
    stroke: "#a7f3d0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 130,
    y: 132,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fill: "#065f46",
    textAnchor: "middle"
  }, "Live Tag Server \xB7 Temperature \xB7 Motor \xB7 Batch")), /*#__PURE__*/React.createElement("path", {
    d: "M340 340 L420 340",
    stroke: "#ea580c",
    strokeWidth: 3,
    markerEnd: "url(#arrowOrange)",
    strokeLinecap: "round",
    strokeDasharray: "8,6"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "14;0",
    dur: "0.8s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M420 380 L340 380",
    stroke: "#059669",
    strokeWidth: 3,
    markerEnd: "url(#arrowGreen)",
    strokeLinecap: "round",
    strokeDasharray: "8,6"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "14;0",
    dur: "0.8s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 345,
    y: 308,
    width: 70,
    height: 18,
    rx: 4,
    fill: "#fff",
    stroke: "#ea580c",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 380,
    y: 321,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 9,
    fontWeight: 600,
    fill: "#9a3412",
    textAnchor: "middle"
  }, "Tag Data"), /*#__PURE__*/React.createElement("rect", {
    x: 345,
    y: 394,
    width: 70,
    height: 18,
    rx: 4,
    fill: "#fff",
    stroke: "#059669",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 380,
    y: 407,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 9,
    fontWeight: 600,
    fill: "#065f46",
    textAnchor: "middle"
  }, "Write Back"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(440,200)",
    filter: "url(#gbShadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 340,
    height: 320,
    rx: 16,
    fill: "url(#cardGrad)",
    stroke: "#fb923c",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 340,
    height: 44,
    rx: 16,
    fill: "url(#nodfloGrad)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 30,
    width: 340,
    height: 14,
    fill: "url(#nodfloGrad)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 170,
    y: 27,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 17,
    fontWeight: 700,
    fill: "#fff",
    textAnchor: "middle"
  }, "\u2699 NodFlo Workflow Engine"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20,60)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 180,
    rx: 12,
    fill: "#fff7ed",
    stroke: "#fed7aa",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 22,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 700,
    fill: "#9a3412",
    textAnchor: "middle"
  }, "Business Logic"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16,36)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86,
    height: 32,
    rx: 6,
    fill: "#ffedd5"
  }), /*#__PURE__*/React.createElement("text", {
    x: 43,
    y: 21,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 600,
    fill: "#9a3412",
    textAnchor: "middle"
  }, "Conditions")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(110,36)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86,
    height: 32,
    rx: 6,
    fill: "#ffedd5"
  }), /*#__PURE__*/React.createElement("text", {
    x: 43,
    y: 21,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 600,
    fill: "#9a3412",
    textAnchor: "middle"
  }, "JavaScript")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(204,36)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 32,
    rx: 6,
    fill: "#ffedd5"
  }), /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 21,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 600,
    fill: "#9a3412",
    textAnchor: "middle"
  }, "Events")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16,78)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86,
    height: 32,
    rx: 6,
    fill: "#ffedd5"
  }), /*#__PURE__*/React.createElement("text", {
    x: 43,
    y: 21,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 600,
    fill: "#9a3412",
    textAnchor: "middle"
  }, "Timers")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(110,78)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86,
    height: 32,
    rx: 6,
    fill: "#ffedd5"
  }), /*#__PURE__*/React.createElement("text", {
    x: 43,
    y: 21,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 600,
    fill: "#9a3412",
    textAnchor: "middle"
  }, "Actions")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(204,78)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 32,
    rx: 6,
    fill: "#ffedd5"
  }), /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 21,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 600,
    fill: "#9a3412",
    textAnchor: "middle"
  }, "Workflow")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16,120)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86,
    height: 32,
    rx: 6,
    fill: "#ffedd5"
  }), /*#__PURE__*/React.createElement("text", {
    x: 43,
    y: 21,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 600,
    fill: "#9a3412",
    textAnchor: "middle"
  }, "Database")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(110,120)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86,
    height: 32,
    rx: 6,
    fill: "#ffedd5"
  }), /*#__PURE__*/React.createElement("text", {
    x: 43,
    y: 21,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 600,
    fill: "#9a3412",
    textAnchor: "middle"
  }, "REST API")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(204,120)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 32,
    rx: 6,
    fill: "#ffedd5"
  }), /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 21,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 600,
    fill: "#9a3412",
    textAnchor: "middle"
  }, "Logic Exec"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(70,250)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 48,
    rx: 8,
    fill: "#fdba74",
    stroke: "#f97316",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 20,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 700,
    fill: "#7c2d12",
    textAnchor: "middle"
  }, "Execute Flow \u2192 Output"), /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 38,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 9,
    fill: "#9a3412",
    textAnchor: "middle"
  }, "Computed values &amp; commands"))), /*#__PURE__*/React.createElement("path", {
    d: "M610 520 L610 560",
    stroke: "#ea580c",
    strokeWidth: 3,
    markerEnd: "url(#arrowOrange)",
    strokeLinecap: "round",
    strokeDasharray: "8,6"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "14;0",
    dur: "0.8s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(440,570)",
    filter: "url(#gbShadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 340,
    height: 120,
    rx: 14,
    fill: "url(#cardGrad)",
    stroke: "#60a5fa",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 340,
    height: 40,
    rx: 14,
    fill: "url(#widgetGrad)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 26,
    width: 340,
    height: 14,
    fill: "url(#widgetGrad)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 170,
    y: 25,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 15,
    fontWeight: 700,
    fill: "#fff",
    textAnchor: "middle"
  }, "\uD83D\uDCCA Update HMI Widgets"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(30,54)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 48,
    rx: 8,
    fill: "#dbeafe"
  }), /*#__PURE__*/React.createElement("text", {
    x: 32,
    y: 30,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fill: "#1d4ed8",
    textAnchor: "middle"
  }, "Gauge")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(104,54)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 48,
    rx: 8,
    fill: "#dbeafe"
  }), /*#__PURE__*/React.createElement("text", {
    x: 32,
    y: 30,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fill: "#1d4ed8",
    textAnchor: "middle"
  }, "Button")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(178,54)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 48,
    rx: 8,
    fill: "#dbeafe"
  }), /*#__PURE__*/React.createElement("text", {
    x: 32,
    y: 30,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fill: "#1d4ed8",
    textAnchor: "middle"
  }, "Chart")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(252,54)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 48,
    rx: 8,
    fill: "#fee2e2"
  }), /*#__PURE__*/React.createElement("text", {
    x: 32,
    y: 30,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fill: "#b91c1c",
    textAnchor: "middle"
  }, "Alarm")), /*#__PURE__*/React.createElement("text", {
    x: 170,
    y: 118,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fill: "#475569",
    textAnchor: "middle"
  }, "Animations \xB7 Alarms \xB7 Live Values")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(820,130)",
    filter: "url(#softShadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 250,
    rx: 14,
    fill: "#fff",
    stroke: "#a7f3d0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 32,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 700,
    fill: "#065f46",
    textAnchor: "middle"
  }, "Integration Features"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20,50)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 28,
    rx: 5,
    fill: "#ecfdf5"
  }), /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 19,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 600,
    fill: "#065f46",
    textAnchor: "middle"
  }, "\u2713 Read / Write")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(124,50)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 28,
    rx: 5,
    fill: "#ecfdf5"
  }), /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 19,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 600,
    fill: "#065f46",
    textAnchor: "middle"
  }, "\u2713 Live Updates")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20,86)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 28,
    rx: 5,
    fill: "#ecfdf5"
  }), /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 19,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 600,
    fill: "#065f46",
    textAnchor: "middle"
  }, "\u2713 Workflow")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(124,86)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 28,
    rx: 5,
    fill: "#ffedd5"
  }), /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 19,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 600,
    fill: "#9a3412",
    textAnchor: "middle"
  }, "\u2713 JavaScript")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20,122)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 28,
    rx: 5,
    fill: "#ffedd5"
  }), /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 19,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 600,
    fill: "#9a3412",
    textAnchor: "middle"
  }, "\u2713 Conditions")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(124,122)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 28,
    rx: 5,
    fill: "#ffedd5"
  }), /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 19,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 600,
    fill: "#9a3412",
    textAnchor: "middle"
  }, "\u2713 Real-Time")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20,158)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 28,
    rx: 5,
    fill: "#dbeafe"
  }), /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 19,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 600,
    fill: "#1d4ed8",
    textAnchor: "middle"
  }, "\u2713 Animations")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(124,158)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 28,
    rx: 5,
    fill: "#fee2e2"
  }), /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 19,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 600,
    fill: "#b91c1c",
    textAnchor: "middle"
  }, "\u2713 Alarms")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20,200)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 34,
    rx: 6,
    fill: "#ecfdf5",
    stroke: "#a7f3d0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 22,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 600,
    fill: "#065f46",
    textAnchor: "middle"
  }, "No CloudView \xB7 No MQTT Broker"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuibuilderNodfloArchitecture);
export default __webpack_public_path__ + "static/media/guibuilder_nodflo_architecture.9d151fb14455d8678804447af74e2b5f.svg";
export { ForwardRef as ReactComponent };